import { formatSimpleDate } from 'util/formatDateTime';

export function getDateRange(daterange: string): string {
  const today = new Date();
  let rangedDay = new Date();
  if (daterange === 'DEFAULT') return '';
  else if (daterange === 'WEEK') rangedDay.setDate(rangedDay.getDate() - 7);
  else if (daterange === 'ONEMONTH') rangedDay.setMonth(rangedDay.getMonth() - 1);
  else if (daterange === 'SIXMONTH') rangedDay.setMonth(rangedDay.getMonth() - 6);
  else rangedDay.setFullYear(rangedDay.getFullYear() - 1);
  console.log(`&daterange=${formatSimpleDate(rangedDay)},${formatSimpleDate(today)}`);
  return `&daterange=${formatSimpleDate(rangedDay)},${formatSimpleDate(today)}`;
}
